import {get, post} from '@/lib/axios';

export default {
    async getBanner(code, brand = 1) {
        return get(`/banners/${code}?brand=${brand}`);
    }
}